import React from "react";
import Link from "gatsby-link";
import GatsbyConfig from "../../../gatsby-config.js";
import Image from "./image";
import Modal from "./modal";
import logo from "../../../static/images/header-lovesong-logo.png";
import { isHawaiiTime, isUrlAllowedInHawaii } from "../../utils/app-helpers.js";

const { siteMetadata: config } = GatsbyConfig;

export default class SiteHeader extends React.Component {
  state = { showModal: false };

  constructor() {
    super();
    this.clickMenu = this.clickMenu.bind(this);
    this.clickClose = this.clickClose.bind(this);
  }

  componentDidMount() {
    const { trip } = this.props;
    const { tripPageModal } = (trip && config.trips[trip]) || {};

    this.setState({
      showModal: !!tripPageModal && tripPageModal.enabled,
    });
  }

  clickMenu() {
    if (typeof window === "undefined") return;
    const { app } = window;

    app.hideMenus();
    app.bodyEl.classList.add("nav-open");
    app.disableScrolling();
  }

  clickClose() {
    if (typeof window === "undefined") return;
    const { app } = window;

    app.hideMenus();
    app.enableScrolling();
  }

  render() {
    const { trip, lock, step, readonly, lockLogo } = this.props;
    const { showModal } = this.state;
    const tripData = config.trips[trip];
    const { tripPageModal } = tripData || {};
    const hstUrlAllowed = isUrlAllowedInHawaii();
    const isHST = isHawaiiTime();

    const orderedTrips = [
      "maui2021",
      "kauai2021",
      "cancun2020",
      "cancun2021",
      "maui2019",
      "kauai2019",
      "maui",
      "cancun",
    ];
    const availableTrips = [];
    const isTripPage = trip && trip !== "none";
    let headerClassName = trip ? `trip-${trip}` : "";

    if (trip && isHST && !hstUrlAllowed) {
      headerClassName += " page-mask lock read-only";
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.href = "/";
      }
    } else {
      if (lock) headerClassName += " lock";
      if (step) headerClassName += " has-step";
      if (readonly) headerClassName += " read-only";

      orderedTrips.forEach((slug, index) => {
        const data = config.trips[slug];

        if (
          !data.available ||
          data.hideLink ||
          (isHST && (data.useHawaiiSplashMasking || data.useHawaiiTripMasking))
        ) {
          return;
        }
        availableTrips.push(
          <Link
            key={`available-trip-${index}`}
            className={`select-${slug}`}
            to={`/${slug}/`}
          >
            <span>
              <i className="fa fa-caret-right" />
              {data.name} {data.year}
              {data.soldOut && <mark className="sold-out">Sold Out</mark>}
            </span>
            <time>
              {data.dates}
              <i className="fa fa-calendar-o" />
            </time>
          </Link>
        );
      });
    }

    return (
      <header className={headerClassName}>
        <div className="wrap">
          <span className="nav" onClick={this.clickMenu}>
            <i className="fa fa-bars" />
          </span>
          <span className="back" onClick={() => history.back()}>
            <i className="fa fa-chevron-left" />
            <span>Back</span>
          </span>
          <nav>
            <span className="close" onClick={this.clickClose}>
              <i className="fa fa-close" />
            </span>
            {tripData && (
              <h4>
                {tripData.name} {tripData.year}
              </h4>
            )}
            {tripData && (
              <span className="group">
                <Link to={`/${trip}/`}>Overview</Link>
                <Link to={`/${trip}/faq/`}>FAQ</Link>
                <Link to={`/${trip}/our-story/`}>Our Story</Link>
                <Link to={`/${trip}/prices/`}>Prices &amp; Booking</Link>
                <Link to={`/${trip}/contact-us/`}>Contact Us</Link>
              </span>
            )}
            {availableTrips.length > 1 && <h4>Getaways</h4>}
            {availableTrips.length > 1 && availableTrips}
          </nav>
          {readonly || lockLogo ? (
            <div className="branding">
              <Image src={logo} alt="Love Song" />
            </div>
          ) : (
            <Link
              className="branding"
              to={isTripPage ? `/${trip}/#top` : "/#top"}
            >
              <Image src={logo} alt="Love Song" />
            </Link>
          )}
          {isTripPage ? (
            <Link className="btn" to={`/${trip}/prices/`}>
              Book
            </Link>
          ) : (
            <a className="btn none">&nbsp;</a>
          )}
          {isNaN(step) ? (
            ""
          ) : (
            <span className="step">
              <span>{step} of 5</span>
              <i className="fa fa-shopping-cart" />
            </span>
          )}
        </div>
        {tripPageModal && tripPageModal.enabled && (
          <Modal
            show={showModal}
            onClose={() => this.setState({ showModal: false })}
            title={tripPageModal.title}
            message={tripPageModal.message}
            messageAlignment={tripPageModal.messageAlignment || "left"}
            buttons={tripPageModal.buttons}
            dismissible={tripPageModal.dismissible}
            lockOverlay
          />
        )}
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/site-header.js